// extracted by mini-css-extract-plugin
module.exports = {"error":"e500_error__22ue9","text1":"e500_text1__2gu88"};